export default "__VITE_ASSET__CvISAdvC__"